import axios from 'axios';

import { Err, ResponseData } from 'types';

import { http } from '.';

export const createSubUser = async (payload) => {
  return await http.post<Err, ResponseData<1>>(
    `/UsersMi/registerSubUser`,
    payload
  );
};

export const updateSubUser = async (payload) => {
  return await http.put<Err, ResponseData<any>>(`/Managers`, payload);
};

export const getSubUsers = async (pageSize: number, pageIndex: number) => {
  return await http.get<Err, ResponseData<any>>(
    `/UsersMi/getSubUserList/subuser?pageSize=${pageSize}&pageIndex=${pageIndex}`
  );
};

export type SubUserListItem = {
  userId: number;
  fullName: string;
  subscriptionExpiryDate?: string | null;
  isUpgradeEnabled?: boolean;
  activeSubscriptionPackageId?: number | null;
};

export const getSubUserListByAccountId = async (
  pageSize = 1000,
  pageIndex = 0
) => {
  return await http.get<Err, ResponseData<any>>(
    `/Payment/getSubUserList/GetSubUserListByAccountId`,
    {
      params: {
        pageSize,
        pageIndex,
      },
    }
  );
};

export const getSubUserRoles = async () => {
  return await http.get<Err, ResponseData<any[]>>(`/Roles/getAllRoles`);
};
export const getPermissionsInvoice = async () => {
  return await http.get<Err, ResponseData<any[]>>(
    `/PermissionToInvoice/getAll`
  );
};
export const getPermissionsInvoiceAdd = async (payload) => {
  return await http.post<Err, ResponseData<1>>(
    `/PermissionToInvoice/tryAddRange`,
    payload
  );
};
export const addToRoleWithForAll = async (payload) => {
  return await http.post<Err, ResponseData<1>>(
    `/UserRoles/addToRoleWithForAll`,
    payload
  );
};

export const getCostRoles = async ({
  pageSize,
  pageIndex,
  userId,
}: {
  pageSize: number;
  pageIndex: number;
  userId: string;
}) => {
  return http.get(
    `PermissionToCostPartner/getPermissionToCostPartnerListPaginated?UserId=${userId}`,
    {
      params: {
        pageSize,
        pageIndex,
      },
    }
  );
};

export const getInvoiceRoles = async ({
  pageSize,
  pageIndex,
  userId,
}: {
  pageSize: number;
  pageIndex: number;
  userId: string;
}) => {
  return http.get(
    `PermissionToInvoice/getPermissionToInvoicesListPaginated?UserId=${userId}`,
    {
      params: {
        pageSize,
        pageIndex,
      },
    }
  );
};

export const getReportRoles = async ({
  pageSize,
  pageIndex,
  userId,
}: {
  pageSize: number;
  pageIndex: number;
  userId: string;
}) => {
  return http.get(
    `PermissionToReport/getPermissionToReportsListPaginated?UserId=${userId}`,
    {
      params: {
        pageSize,
        pageIndex,
      },
    }
  );
};

export const getExistingRolesCost = async (userId, partnerId) => {
  return await http.get<Err, ResponseData<1>>(
    `PermissionToCostPartner/getExistingRolesByPartner?userId=${userId}&partnerId=${partnerId}`
  );
};

export const getExistingRolesInvoice = async (userId, partnerId) => {
  return await http.get<Err, ResponseData<1>>(
    `PermissionToInvoice/getExistingRolesByPartner?userId=${userId}&partnerId=${partnerId}`
  );
};

export const getExistingRolesReport = async (userId, reportId) => {
  return await http.get<Err, ResponseData<1>>(
    `PermissionToReport/getExistingRolesByReport?userId=${userId}&reportId=${reportId}`
  );
};

export const setForAllViewInvoice = async (userId, status) => {
  return await http.post<Err, ResponseData<1>>(
    `PermissionToInvoice/setForAllView?userId=${userId}&status=${status}`
  );
};
export const setForAllAddInvoice = async (userId, status) => {
  return await http.post<Err, ResponseData<1>>(
    `PermissionToInvoice/setForAllAdd?userId=${userId}&status=${status}`
  );
};
export const setForAllUpdateInvoice = async (userId, status) => {
  return await http.post<Err, ResponseData<1>>(
    `PermissionToInvoice/setForAllUpdate?userId=${userId}&status=${status}`
  );
};
export const setForAllDeleteInvoice = async (userId, status) => {
  return await http.post<Err, ResponseData<1>>(
    `PermissionToInvoice/setForAllDelete?userId=${userId}&status=${status}`
  );
};

export const setForAllViewCost = async (userId, status) => {
  return await http.post<Err, ResponseData<1>>(
    `PermissionToCostPartner/setForAllView?userId=${userId}&status=${status}`
  );
};
export const setForAllAddCost = async (userId, status) => {
  return await http.post<Err, ResponseData<1>>(
    `PermissionToCostPartner/setForAllAdd?userId=${userId}&status=${status}`
  );
};
export const setForAllUpdateCost = async (userId, status) => {
  return await http.post<Err, ResponseData<1>>(
    `PermissionToCostPartner/setForAllUpdate?userId=${userId}&status=${status}`
  );
};
export const setForAllDeleteCost = async (userId, status) => {
  return await http.post<Err, ResponseData<1>>(
    `PermissionToCostPartner/setForAllDelete?userId=${userId}&status=${status}`
  );
};

export const setForAllViewReport = async (userId, status) => {
  return await http.post<Err, ResponseData<1>>(
    `PermissionToReport/setForAllView?userId=${userId}&status=${status}`
  );
};

export const resendLink = async (payload) => {
  return await http.post<Err, ResponseData<1>>(
    `/UsersMi/sendActivationLinkAgain`,
    payload
  );
};

export const getPermissionsCostAdd = async (payload) => {
  return await http.post<Err, ResponseData<1>>(
    `/PermissionToCostPartner/tryAddRange`,
    payload
  );
};
export const getPermissionsReportAdd = async (payload) => {
  return await http.post<Err, ResponseData<1>>(
    `/PermissionToReport/tryAddRange`,
    payload
  );
};

export const getPermissionsInvoiceUpdate = async (payload) => {
  return await axios.put<Err, ResponseData<any>>(
    `https://38.242.208.6:88/api/PermissionToInvoice/update`,
    payload
  );
};
export const getPermissionsCostUpdate = async (payload) => {
  return await axios.put<Err, ResponseData<any>>(
    `https://38.242.208.6:88/api/PermissionToCostPartner/update`,
    payload
  );
};
export const getPermissionsReportUpdate = async (payload) => {
  return await axios.put<Err, ResponseData<any>>(
    `https://38.242.208.6:88/api/PermissionToReport/update`,
    payload
  );
};

export const getPermissionsInvoiceDelete = async (id: number) => {
  return await axios.delete<Err, ResponseData<any>>(
    `https://38.242.208.6:88/api/PermissionToInvoice/delete`,
    {
      data: id,
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    }
  );
};
export const getPermissionsCostDelete = async (id: number) => {
  return await axios.delete<Err, ResponseData<any>>(
    `https://38.242.208.6:88/api/PermissionToCostPartner/delete`,
    {
      data: id,
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    }
  );
};

export const getPermissionsReportDelete = async (id: number) => {
  return await axios.delete<Err, ResponseData<any>>(
    `https://38.242.208.6:88/api/PermissionToReport/delete`,
    {
      data: id,
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    }
  );
};

export const deleteSubUser = async (managerId: number) => {
  return await http.delete<Err, ResponseData<boolean>>(`Managers/${managerId}`);
};

export const getPermissionsInvoiceById = async (userId) => {
  return await http.get<Err, ResponseData<any[]>>(
    `/PermissionToInvoice/getPermissionToInvoicesList/${userId}`
  );
};
export const getCostCheckRoleEquivalents = async (userId) => {
  return await http.get<Err, ResponseData<any[]>>(
    `/PermissionToCostPartner/checkRoleEquivalents/${userId}`
  );
};

export const getInvoiceCheckRoleEquivalents = async (userId) => {
  return await http.get<Err, ResponseData<any[]>>(
    `/PermissionToInvoice/checkRoleEquivalents/${userId}`
  );
};

export const getReportCheckRoleEquivalents = async (userId) => {
  return await http.get<Err, ResponseData<any[]>>(
    `/PermissionToReport/checkRoleEquivalents/${userId}`
  );
};

export const getPermissionsCostById = async (userId) => {
  return await http.get<Err, ResponseData<any[]>>(
    `/PermissionToCostPartner/getPermissionToCostPartnerList/${userId}`
  );
};
export const getPermissionsReportById = async (userId) => {
  return await http.get<Err, ResponseData<any[]>>(
    `/PermissionToReport/getPermissionToReportsList/${userId}`
  );
};

export const deletePermissionsInvoiceAll = async (id) => {
  return await axios.delete<Err, ResponseData<boolean>>(
    `https://38.242.208.6:88/api/PermissionToInvoice/deleteAll`,
    {
      headers: {
        'Content-Type': 'application/json',
      },
      data: JSON.stringify(id),
    }
  );
};
export const deletePermissionsCostAll = async (id) => {
  return await axios.delete<Err, ResponseData<boolean>>(
    `https://38.242.208.6:88/api/PermissionToCostPartner/deleteAll`,
    {
      headers: {
        'Content-Type': 'application/json',
      },
      data: JSON.stringify(id),
    }
  );
};

export const deletePermissionsReportAll = async (id) => {
  return await axios.delete<Err, ResponseData<boolean>>(
    `https://38.242.208.6:88/api/PermissionToReport/deleteAll`,
    {
      headers: {
        'Content-Type': 'application/json',
      },
      data: JSON.stringify(id),
    }
  );
};

export const addSubUserRole = async (payload) => {
  return await http.post<Err, ResponseData<1>>(
    `/UserRoles/addToRoles`,
    payload
  );
};
export const getSubUserRolesById = async (id) => {
  return await http.get<Err, ResponseData<any[]>>(
    `/UserRoles/getUserRolesByUserId?userId=${id}`
  );
};
